enum WorkspaceProjectGalleryStatus {
  active = 'active',
  deleted = 'deleted',
}

export default WorkspaceProjectGalleryStatus
